/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneCheckoutBody as ResolvedStandaloneCheckoutBody } from 'base/components/standalone/CheckoutBody';

export const CheckoutBody: typeof ResolvedStandaloneCheckoutBody = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneCheckoutBody {...props} />
        </ErrorBoundary>
    );
});

export type CheckoutBodyProps = PropsFromComponent<typeof CheckoutBody>;

/** @deprecated Use slot architecture instead */
export const CheckoutBodyWith = (extras: DynamicStandaloneExtras): typeof CheckoutBody => {
    return function CheckoutBody(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'CheckoutBody');
        return <ResolvedStandaloneCheckoutBody {...mergeProps({ options: { theme } }, props)} />;
    }
}